import Phaser from 'phaser'
import { LAYER_OBJECTS } from '../layers'

export default class Oilslick extends Phaser.GameObjects.Image {
  constructor (scene, x, y) {
    super(scene, x, y, 'environ', 'oil')
    this.setRotation(scene.rnd.frac() * Math.PI)
    this.setScale(0.7)
    this.setOrigin(0.5)
    this.setDepth(LAYER_OBJECTS)

    this.slipped = false
  }

  initialize () {
    this.body.setSize(this.displayWidth * 0.8, this.displayHeight * 0.8)
  }

  onCollision (car, isPlayer) {
    if (isPlayer && !this.slipped && !car.isGameOver && car.hasMoved) {
      this.slipped = true
      car.slip()
    }
  }
}
